import { apiRoutes } from '@features/campaigns/thematicPackage/consts/apiRoutes.ts';
import {
  CreateThematicPackageCampaignPayload,
  CreateThematicPackageCampaignResponse,
} from '@features/campaigns/thematicPackage/types/thematicPackage.types.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign.ts';

export async function createThematicPackageCampaign(
  campaignId: CampaignId,
  payload: CreateThematicPackageCampaignPayload,
): Promise<CreateThematicPackageCampaignResponse | null> {
  return await apiClient.post<CreateThematicPackageCampaignPayload, CreateThematicPackageCampaignResponse>(
    apiRoutes.createThematicPackageCampaign(campaignId),
    payload,
  );
}
